export default __webpack_public_path__ + "static/char-s-08-cht-fdd620b0b709ff46efc02f9547764889.png";